const BASE_BUTTON = [
  "akv:inline-flex akv:h-10 akv:min-h-10 akv:min-w-0 akv:appearance-none akv:items-center",
  "akv:justify-center akv:gap-2 akv:whitespace-nowrap akv:rounded-ak-control akv:border-0",
  "akv:px-4 akv:font-ak-body akv:text-sm akv:font-bold",
  "akv:leading-none akv:no-underline akv:transition-colors akv:duration-150 akv:cursor-pointer",
  "akv:focus-visible:outline-[3px] akv:focus-visible:outline-offset-2 akv:focus-visible:outline-ak-focus",
  "akv:disabled:cursor-not-allowed akv:disabled:opacity-[0.58]",
].join(" ");

const INTENT_CLASSES = {
  primary: "akv:bg-ak-brand akv:text-ak-brand-ink akv:shadow-ak-brand-halo akv:hover:bg-ak-brand-hover",
  secondary: "akv:bg-ak-subtle akv:text-ak-text akv:hover:bg-ak-brand-soft akv:hover:text-ak-brand-hover",
  quiet: "akv:bg-transparent akv:text-ak-brand akv:hover:bg-ak-subtle akv:hover:text-ak-brand-hover",
  destructive: "akv:bg-ak-critical-soft akv:text-ak-critical akv:hover:bg-ak-critical akv:hover:text-ak-surface",
};

export const buttonClassName = (intent, iconOnly = false) => [
  BASE_BUTTON,
  INTENT_CLASSES[intent],
  iconOnly ? "akv:w-10 akv:flex-none akv:px-0" : "",
].filter(Boolean).join(" ");

// Row actions keep a visible hit area at rest, unlike quiet text actions.
export const iconActionClassName = (intent) => [
  BASE_BUTTON,
  intent === "quiet"
    ? "akv:bg-ak-brand-soft akv:text-ak-brand-hover akv:shadow-ak-surface akv:[&:not(:disabled):not([aria-disabled])]:hover:bg-ak-brand akv:[&:not(:disabled):not([aria-disabled])]:hover:text-ak-brand-ink"
    : INTENT_CLASSES[intent],
  "akv:w-10 akv:flex-none akv:px-0 akv:motion-reduce:transition-none",
  "akv:aria-disabled:cursor-not-allowed akv:aria-disabled:opacity-[0.58]",
].join(" ");

export const BUTTON_ICON_CLASS = "akv:inline-flex akv:flex-none akv:items-center akv:justify-center akv:leading-none";
// `leading-none` + `overflow-hidden` rognaient l'accent des capitales
// (« Écarter » s'affichait « Ecarter ») : une marge verticale laisse la place
// aux diacritiques sans changer ni la police ni la hauteur du bouton.
export const BUTTON_LABEL_CLASS = "akv:overflow-hidden akv:text-ellipsis akv:py-[0.15em]";
export const BUTTON_SPINNER_CLASS = [
  "akv:box-border akv:h-4 akv:w-4 akv:flex-none akv:animate-spin akv:rounded-full",
  "akv:border-2 akv:border-solid akv:border-current akv:border-r-transparent",
  "akv:motion-reduce:duration-[1400ms]",
].join(" ");
